import React from "react";
import "./ApprovalSP.css";
import { getDateUtil } from "../../util/formatDate";
import { validateRole } from "../../util/utilFunction";
import { useApprovalSP } from "./useApprovalSP";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import EditLogo from "../../Assets/editLogo.png";
import moment from "moment";
import DeleteIcon from "../../Assets/delete_icon.png";

const ApprovalSP = () => {
  const {
    dataUser,
    dateApprovalLaporanSP,
    setDateApprovalLaporanSP,
    listLaporanSP,
    handleApproveLaporanSP,
    popUpKirim,
    setPopUpKirim,
    isEdit,
    setIsEdit,
    handleFormChange,
    dataTemp,
    filterProduk,
    setFilterProduk,
    filterProdukSelect,
    dataDelete,
    popUpDelete,
    handleSetDataDelete,
    handleCancelDelete,
    handleDeleteLaporan,
  } = useApprovalSP();

  const sortData =
    dataTemp &&
    dataTemp.sort(function (a, b) {
      if (Number(a.mesin) < Number(b.mesin)) {
        return -1;
      }
      if (Number(a.mesin) > Number(b.mesin)) {
        return 1;
      }
      return 0;
    });

  return (
    <div className="container_dashboard asp-page">
      {popUpKirim ? (
        <PopUpComponent>
          <p>Data Laporan Sudah Dikirim!</p>
          <div className="asp-popup-actions">
            <button
              className="asp-popup-btn"
              onClick={() => setPopUpKirim(false)}
            >
              OK
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpDelete ? (
        <PopUpComponent>
          <p>
            Apakah Kamu Yakin ingin menghapus laporan{" "}
            <b> {dataDelete && dataDelete.jenisPekerjaan} </b>
            {dataDelete && dataDelete.operator}, &nbsp;Produk&nbsp;
            <b>{dataDelete && dataDelete.produk} </b>?
          </p>
          <div className="asp-popup-actions">
            <button
              className="asp-popup-btn asp-popup-btn-secondary"
              onClick={() => handleCancelDelete()}
            >
              Cancel
            </button>
            <button
              className="asp-popup-btn"
              onClick={() => handleDeleteLaporan()}
            >
              Yakin
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      <p className="asp-title">APPROVAL LAPORAN SP</p>
      <div className="asp-filter">
        <div className="asp-field">
          <p>Pilih Tanggal</p>
          <input
            type="date"
            className="asp-date"
            value={dateApprovalLaporanSP}
            onChange={(e) => setDateApprovalLaporanSP(e.target.value)}
          />
        </div>
        <div className="asp-field">
          <p>Pilih Produk</p>
          <select
            className="asp-select"
            value={filterProduk}
            onChange={(e) => setFilterProduk(e.target.value)}
          >
            <option selected={filterProduk === "Pilih Produk"} disabled>
              Pilih Produk
            </option>

            {filterProdukSelect &&
              filterProdukSelect.map((data) => (
                <option value={data}>{data}</option>
              ))}
          </select>
        </div>
        <div className="asp-field">
          <p
            className="asp-btn-reset"
            onClick={() => setFilterProduk("Pilih Produk")}
          >
            Reset
          </p>
        </div>
      </div>
      <div className="asp-card-grid">
        {sortData &&
          sortData.map((data, index) => {
            const downtime = Number(data.downtime) ? Number(data.downtime) : 0;
            const formulaTargetProduksi =
              data.target * ((480 - downtime) / 480);
            return (
              <div className="asp-card">
                <div className="asp-card-meta">
                  <p>
                    {moment(data.dateSubmit).utcOffset(7).format("DD-MM-YYYY")}
                  </p>
                  <p>
                    {moment(data.dateSubmit).utcOffset(7).format("HH:mm:ss")}
                  </p>
                </div>
                <div className="asp-card-head">
                  <p className="asp-machine">Mesin&nbsp;{data.mesin}</p>
                  <img
                    className="asp-icon asp-icon-delete"
                    alt="delete-icon"
                    src={DeleteIcon}
                    onClick={() => handleSetDataDelete(data)}
                  />
                  <img
                    className="asp-icon asp-icon-edit"
                    onClick={() => setIsEdit(true)}
                    src={EditLogo}
                    alt="edit_logo"
                  />
                </div>
                <div className="asp-row">
                  <p>
                    {data && data.operator.split(" ").slice(0, 2).join(" ")}
                  </p>
                  <p>{moment(data.date).format("DD MMM YYYY")}</p>
                </div>
                <div className="asp-row">
                  <p className="asp-strong">{data.produk}</p>
                </div>
                <div className="asp-row">
                  {data && data.color !== "" ? (
                    <p className="asp-strong">{data.color}</p>
                  ) : (
                    ""
                  )}
                  <p className="asp-strong">{data.customer}</p>
                  <p className="asp-strong">{data.jenisPekerjaan}</p>
                </div>
                <div className="asp-row">
                  <div>
                    <p className="asp-label">TARGET PENGERJAAN</p>
                    <p
                      className={
                        formulaTargetProduksi > data.jumlahOk + data.reject
                          ? "asp-value asp-value-warn"
                          : "asp-value"
                      }
                    >
                      {formulaTargetProduksi.toFixed(0)}
                    </p>
                  </div>
                  <div>
                    <p className="asp-label">BAGIAN</p>
                    <p className="asp-value">{data.bagian}</p>
                  </div>
                </div>
                <div className="asp-row">
                  <div>
                    <p className="asp-label">REJECT</p>
                    <p className="asp-value">{data.reject}</p>
                  </div>
                  <div>
                    <p className="asp-label">REPAIR</p>
                    <p className="asp-value">{data.repair}</p>
                  </div>
                  <div>
                    <p className="asp-label">OK</p>
                    <p className="asp-value">{data.jumlahOk}</p>
                  </div>
                </div>
                <div className="asp-row">
                  <div>
                    <p className="asp-label">JUMLAH PENGERJAAN</p>
                    <p className="asp-value">{data.jumlahPengerjaan}</p>
                  </div>
                  <div>
                    <p className="asp-label">DOWNTIME</p>
                    {!isEdit ? (
                      <p className="asp-value">{data.downtime} ( Menit )</p>
                    ) : (
                      <input
                        type="number"
                        className="asp-input"
                        name="downtime"
                        value={data.downtime}
                        onChange={(e) => handleFormChange(index, e)}
                        onWheel={(e) => e.target.blur()}
                      />
                    )}
                  </div>
                </div>
                {validateRole() === "PR" ? (
                  <>
                    <p className="asp-section-label">Kind Of Repair</p>
                    <div className="asp-table-scroll">
                      <table className="asp-table">
                        <tr>
                          <th className="asp-th">Repair</th>
                          <th className="asp-th">Tgl</th>
                          <th className="asp-th">Total</th>
                        </tr>
                        {data &&
                          data.dataRepair.map((obj, index) => {
                            return (
                              <tr>
                                <td className="asp-td">{obj.id}</td>
                                <td className="asp-td">{obj.dateRepair}</td>
                                <td className="asp-td">{obj.repair}</td>
                              </tr>
                            );
                          })}
                      </table>
                    </div>
                  </>
                ) : (
                  ""
                )}
                <p className="asp-section-label">Kind Of Reject</p>
                <div className="asp-table-scroll">
                  <table className="asp-table asp-table-fixed">
                    <tr>
                      <th className="asp-th">Reject</th>
                      <th className="asp-th">Tgl</th>
                      <th className="asp-th">Bagian</th>
                      <th className="asp-th">Total</th>
                    </tr>
                    {data.dataReject &&
                      data.dataReject.map((obj, index) => {
                        return (
                          <tr>
                            <td className="asp-td">{obj.id}</td>
                            <td className="asp-td">{obj.dateReject}</td>
                            <td className="asp-td">
                              {obj.shift ? obj.shift : obj.bagian}
                            </td>
                            <td className="asp-td">{obj.reject}</td>
                          </tr>
                        );
                      })}
                  </table>
                </div>

                <p className="asp-section-label">Packing List</p>
                <div className="asp-table-scroll">
                  <table className="asp-table">
                    <tr>
                      <th className="asp-th">Tgl</th>
                      <th className="asp-th">Mc</th>
                      <th className="asp-th">Shift</th>
                      <th className="asp-th">Operator</th>
                      <th className="asp-th">Jumlah</th>
                      <th className="asp-th">Keterangan</th>
                    </tr>
                    {data.dataPacking &&
                      data.dataPacking.map((obj, index) => {
                        return (
                          <tr>
                            <td className="asp-td">
                              {moment(obj.date).format("YYYY-MM-DD")}
                            </td>
                            <td className="asp-td">{obj.mesin}</td>
                            <td className="asp-td">{obj.shift}</td>
                            <td className="asp-td">{obj.operator}</td>
                            <td className="asp-td">{obj.jumlah}</td>
                            <td className="asp-td">{obj.keterangan}</td>
                          </tr>
                        );
                      })}
                  </table>
                </div>
                <div>
                  <p className="asp-section-label">Keterangan</p>
                  {data.keterangan &&
                    data.keterangan.split("\n").map((subStr) => {
                      return <p>{subStr}</p>;
                    })}
                </div>
              </div>
            );
          })}
      </div>
      {sortData && sortData.length > 0 ? (
        <button className="asp-submit" onClick={() => handleApproveLaporanSP()}>
          Kirim
        </button>
      ) : (
        ""
      )}
    </div>
  );
};
export default ApprovalSP;
